<div class="picklist-packing__wrapper">
  <mat-card class="lum-mat-card">
    <div class="flex justify-space-between align-items-center my-3 w-100">
      <h3>Packing</h3>
      <div class="flex gap-2 align-items-center">
        <div class="flex mr-2">
          WIP Bin:
          <a
            class="ml-1 text-underline"
            [routerLink]="['/locations/s', currentTempLocation?.id, 'details']"
          >
            {{ currentTempLocation?.locationName }}</a
          >
        </div>
        <div class="flex">
          Sales Order Number(s):
          <div class="picklist-packing__orderNumber ml-1">
            <ng-container
              *ngFor="
                let orderNumber of orderNumbers;
                let i = index;
                trackBy: trackByValue
              "
            >
              <a
                *ngIf="i < orderNumberMaxDisplay"
                target="_blank"
                [routerLink]="['/shipping/posted-orders']"
                [queryParams]="{ orderNumber: orderNumber }"
              >
                {{ orderNumber }}
              </a>
            </ng-container>

            <span
              *ngIf="orderNumbers.length > 4"
              class="text-underline cursor-pointer"
            >
              <span
                *ngIf="orderNumberMaxDisplay === 4; else showLess"
                (click)="orderNumberMaxDisplay = orderNumbers.length"
              >
                Show more({{ orderNumbers.length - 4 }})
              </span>
              <ng-template #showLess
                ><span (click)="orderNumberMaxDisplay = 4">
                  Show less
                </span></ng-template
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="flex justify-space-between align-items-center mb-3 w-100">
      <div></div>
      <div class="action-btn-group my-2">
        <button
          mat-button
          class="lum-button lum-button--secondary"
          [matMenuTriggerFor]="bulkMenu"
        >
          ({{ this.selectedItems.length }}) Bulk Action
        </button>
        <mat-menu #bulkMenu="matMenu">
          <button mat-menu-item (click)="bulkExportShippingLabels()">
            <lum-ui-icon
              class="mr-3"
              icon="export-pdf"
              color="var(--col-primary)"
            ></lum-ui-icon>
            Export Shipping Label(s)
          </button>
          <button mat-menu-item (click)="bulkExportShippingLabelsWithPackingSlip()">
            <lum-ui-icon
              class="mr-3"
              icon="export-pdf"
              color="var(--col-primary)"
            ></lum-ui-icon>
            Export Label(s) w/ Packing Slip
          </button>
          <button
            mat-menu-item
            [disabled]="loading || selectedItems.length <= 0"
            (click)="printShippingLabels()"
          >
            <lum-ui-icon
              class="pr-1 pb-1"
              icon="file-add"
              [color]="
                loading || selectedItems.length <= 0
                  ? 'currentColor'
                  : 'var(--col-primary)'
              "
            ></lum-ui-icon>
            Print Shipping Labels
          </button>
          <button
            [disabled]="checkedItemNeedToVerifyCount <= 0"
            mat-menu-item
            (click)="bulkVerify()"
          >
            ({{ checkedItemNeedToVerifyCount }})
            <lum-ui-icon
              class="mr-1"
              icon="search"
              [color]="
                checkedItemNeedToVerifyCount <= 0
                  ? 'currentColor'
                  : 'var(--col-primary)'
              "
              width="22"
              height="22"
            ></lum-ui-icon>
            Verify
          </button>
          <button
            [disabled]="checkedItemReadyToShipCount <= 0 || loadingBulkShip"
            mat-menu-item
            (click)="bulkShip()"
          >
            ({{ checkedItemReadyToShipCount }})
            <lum-ui-icon
              class="pr-1 pb-1"
              icon="shipping"
              [color]="
                checkedItemReadyToShipCount <= 0
                  ? 'currentColor'
                  : 'var(--col-primary)'
              "
              width="22"
              height="22"
            ></lum-ui-icon>
            Ship
          </button>
        </mat-menu>
      </div>
    </div>
    <mat-divider class=""></mat-divider>
    <mat-card-content>
      <lum-picklist-packing-table
        [picklist]="currentPicklist$ | async"
        [loading]="(loading$ | async) || false"
        [loadingBulkShip]="loadingBulkShip"
        [updatingStatus]="(updatingStatus$ | async) || loading"
        (shipEvent)="shipItem($event)"
        (onHoldEvent)="holdItem($event)"
        (verifyEvent)="onVerifyPacking($event)"
        (exportPackingSlipEvent)="exportPackingSlip($event)"
        (printLabelEvent)="printLabel($event)"
        (printLabelWithPackingSlipEvent)="printLabelWithPackingSlip($event)"
        (flagOrderEvent)="flagOrder($event)"
        [data]="(currentPicklistPacking$ | async) || []"
        (selectEvent)="onSelectionChange($event)"
      ></lum-picklist-packing-table>
    </mat-card-content>
    <mat-card-actions align="end">
      <button
        *ngIf="showPicklistActions"
        type="button"
        class="lum-button"
        mat-button
        [disabled]="!canFinishPicklist || packFinishLoading"
        (click)="onFinishPicklist()"
      >
        <lum-ui-icon
          [icon]="'shipping'"
          width="14"
          height="14"
          color="#fff"
          class="mr-2"
        ></lum-ui-icon>
        Finish
      </button>
    </mat-card-actions>
  </mat-card>
</div>
